import React from "react";
import {FieldError, useWatch} from "react-hook-form";
import {css} from "@emotion/react";

import {calculateRemSize, mb, p} from "@pg-design/helpers-css-strings";
import {CheckBoxGroupControlled, RadioGroupControlled, TextareaField} from "@pg-design/rhf-components-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useAppDispatch} from "../../../store/hooks";
import {additionalAreasOptions, dateOptions, floorOptions, kitchenOptions, quartersOptions} from "../../constants/additional_form_options";
import {setForYouAdditional} from "../../state/for_you_modal_slice";
import {SubmitHandlerType} from "../../types/SubmitHandlerType";
import {ForYouModalButton} from "../modal_parts/ForYouModalButton";

interface IProps {
    submitHandler: SubmitHandlerType;
    onNextStep: () => void;
    onSubmitError?: (name: string, error: FieldError) => void;
}

export const ForYouAdditionalForm = (props: IProps) => {
    const dispatch = useAppDispatch();
    const additional_areas = useWatch({name: "additional_areas"});
    const kitchen = useWatch({name: "kitchen"});
    const floor = useWatch({name: "floor"});
    const date = useWatch({name: "date"});
    const quarters = useWatch({name: "quarters"});
    const message = useWatch({name: "message"});

    const onSubmit = () => {
        //TODO remove log after test (its for testers to check regions data that will be send)
        console.log(
            "Zapisuję dodatkowe kryteria(numerki przy np. terminie wynikają z tego że tak w innych miejscach aplikacji przekazujemy dany parametr):",
            `\npowierzchnia dodatkowa: ${additional_areas}`,
            `\nkuchnia: ${kitchen}`,
            `\npiętro: ${floor}`,
            `\ntermin: ${date}`,
            `\nstrona świata: ${quarters}`,
            `\nwiadomość:\n"${message}"`
        );
        dispatch(setForYouAdditional({additional_areas, kitchen, floor, date, quarters, message}));
        props.onNextStep();
    };

    return (
        <form onSubmit={props.submitHandler(onSubmit)} css={formStyle}>
            <div className="filed-wrapper">
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Powierzchnie dodatkowe
                </Text>

                <RadioGroupControlled name="additional_areas" options={additionalAreasOptions} className="list-style" optionClassName="option-style" />
            </div>

            <div className="filed-wrapper">
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Kuchnia
                </Text>

                <RadioGroupControlled name="kitchen" options={kitchenOptions} className="list-style" optionClassName="option-style" />
            </div>

            <div className="filed-wrapper">
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Piętro
                </Text>

                <CheckBoxGroupControlled name="floor" options={floorOptions} />
            </div>

            <div className="filed-wrapper">
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Strona świata
                </Text>

                <CheckBoxGroupControlled name="quarters" options={quartersOptions} />
            </div>

            <div className="filed-wrapper">
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Termin oddania
                </Text>

                <RadioGroupControlled name="date" options={dateOptions} className="list-style" optionClassName="option-style" />
            </div>

            <div className="filed-wrapper">
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Twoje dodatkowe uwagi
                </Text>

                <TextareaField name="message" placeholder="Napisz, na co zwrócić szczególną uwagę podczas poszukiwań nieruchomości." />
            </div>

            <ForYouModalButton />
        </form>
    );
};

const formStyle = css`
    width: 100%;
    background-color: ${getThemeVariable("colors.gray.100")};
    ${p(3, 1.5, 0, 1.5)};

    .filed-wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: ${calculateRemSize(2)};
        ${mb(2)};
        ${p(2)};
        background-color: #fff;
        border-radius: ${calculateRemSize(1)};
        p {
            white-space: nowrap;
        }
    }

    .list-style {
        gap: ${calculateRemSize(3)};
        flex-direction: column;

        @media (min-width: ${getThemeBreakpoint().md}) {
            flex-direction: row;
        }
    }

    ul {
        display: flex;
        gap: ${calculateRemSize(3)};
        flex-direction: column;

        @media (min-width: ${getThemeBreakpoint().md}) {
            flex-direction: row;
        }
    }

    .option-style {
        flex: 0;
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(3, 5, 3, 5)};
    }
`;
import React from "react";
import {FieldError, useWatch} from "react-hook-form";
import {css} from "@emotion/react";

import {calculateRemSize, mb, p} from "@pg-design/helpers-css-strings";
import {CheckBoxGroupControlled, RadioGroupControlled, TextareaField} from "@pg-design/rhf-components-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useAppDispatch} from "../../../store/hooks";
import {additionalAreasOptions, dateOptions, floorOptions, kitchenOptions, quartersOptions} from "../../constants/additional_form_options";
import {setForYouAdditional} from "../../state/for_you_modal_slice";
import {SubmitHandlerType} from "../../types/SubmitHandlerType";
import {ForYouModalButton} from "../modal_parts/ForYouModalButton";

interface IProps {
    submitHandler: SubmitHandlerType;
    onNextStep: () => void;
    onSubmitError?: (name: string, error: FieldError) => void;
}

export const ForYouAdditionalForm = (props: IProps) => {
    const dispatch = useAppDispatch();
    const additional_areas = useWatch({name: "additional_areas"});
    const kitchen = useWatch({name: "kitchen"});
    const floor = useWatch({name: "floor"});
    const date = useWatch({name: "date"});
    const quarters = useWatch({name: "quarters"});
    const message = useWatch({name: "message"});

    const onSubmit = () => {
        //TODO remove log after test (its for testers to check regions data that will be send)
        console.log(
            "Zapisuję dodatkowe kryteria(numerki przy np. terminie wynikają z tego że tak w innych miejscach aplikacji przekazujemy dany parametr):",
            `\npowierzchnia dodatkowa: ${additional_areas}`,
            `\nkuchnia: ${kitchen}`,
            `\npiętro: ${floor}`,
            `\ntermin: ${date}`,
            `\nstrona świata: ${quarters}`,
            `\nwiadomość:\n"${message}"`
        );
        dispatch(setForYouAdditional({additional_areas, kitchen, floor, date, quarters, message}));
        props.onNextStep();
    };

    return (
        <form onSubmit={props.submitHandler(onSubmit)} css={formStyle}>
            <div className="filed-wrapper">
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Powierzchnie dodatkowe
                </Text>

                <RadioGroupControlled name="additional_areas" options={additionalAreasOptions} className="list-style" optionClassName="option-style" />
            </div>

            <div className="filed-wrapper">
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Kuchnia
                </Text>

                <RadioGroupControlled name="kitchen" options={kitchenOptions} className="list-style" optionClassName="option-style" />
            </div>

            <div className="filed-wrapper">
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Piętro
                </Text>

                <CheckBoxGroupControlled name="floor" options={floorOptions} />
            </div>

            <div className="filed-wrapper">
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Strona świata
                </Text>

                <CheckBoxGroupControlled name="quarters" options={quartersOptions} />
            </div>

            <div className="filed-wrapper">
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Termin oddania
                </Text>

                <RadioGroupControlled name="date" options={dateOptions} className="list-style" optionClassName="option-style" />
            </div>

            <div className="filed-wrapper">
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Twoje dodatkowe uwagi
                </Text>

                <TextareaField name="message" placeholder="Napisz, na co zwrócić szczególną uwagę podczas poszukiwań nieruchomości." />
            </div>

            <ForYouModalButton />
        </form>
    );
};

const formStyle = css`
    width: 100%;
    background-color: ${getThemeVariable("colors.gray.100")};
    ${p(3, 1.5, 0, 1.5)};

    .filed-wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: ${calculateRemSize(2)};
        ${mb(2)};
        ${p(2)};
        background-color: #fff;
        border-radius: ${calculateRemSize(1)};
        p {
            white-space: nowrap;
        }
    }

    .list-style {
        gap: ${calculateRemSize(3)};
        flex-direction: column;

        @media (min-width: ${getThemeBreakpoint().md}) {
            flex-direction: row;
        }
    }

    ul {
        display: flex;
        gap: ${calculateRemSize(3)};
        flex-direction: column;

        @media (min-width: ${getThemeBreakpoint().md}) {
            flex-direction: row;
        }
    }

    .option-style {
        flex: 0;
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(3, 5, 3, 5)};
    }
`;
